/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_TrackInputs */



/**
* | output |
* | --- |
* | "Compare Track" |
*
* @param {Compare_TrackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_track = /** @type {((inputs?: Compare_TrackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_TrackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Piste de comparaison")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vergleichen Sie die Strecke")
	if (locale === "it") return /** @type {LocalizedString} */ ("Confronta traccia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сравнить трек")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comparar pista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("比较轨道")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラックを比較")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक की तुलना करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Comparar faixa")
	return /** @type {LocalizedString} */ ("Compare Track")
});